<template>
  <!-- 下载中心 -->
  <div @click="closeQR" class="download animate__animated init--zzQhF section" id="download">
    <div class="download_box maxWidth">
      <div class="download-main">
        <div class="download-main-title">
          <span></span>
          <span>下载中心</span>
        </div>
        <div class="download-main_flex">
          <div class="download-main-info">
            <div>
              <!-- <img src="./images/pc/download-main-infobg1.gif" alt=""> -->
            </div>
            <div class="download-main-info-right">
              <div>
                <div class="download-main-info-right-center">
                  <div class="ios"></div>
                  <div class="iosSize">IOS下载</div>
                  <a @click="downloadApp(2)">立即下载</a>
                </div>
              </div>
              <div>
                <div class="download-main-info-right-center">
                  <div class="android"></div>
                  <div class="androidSize">Android</div>
                  <a @click="downloadApp(3)">立即下载</a>
                </div>
              </div>
              <div>
                <div class="download-main-info-right-center">
                  <div class="mn"></div>
                  <div class="androidSize">模拟器</div>
                  <a @click="downloadApp(4)">立即下载</a>
                </div>
              </div>
              <div>
                <div class="download-main-info-right-center">
                  <div class="pc"></div>
                  <div class="pcSize">千年游戏盒子电脑版本</div>
                  <a @click="downloadApp(1)">立即下载</a>
                </div>
              </div>
              <div class="">
                <div @click="pcqrShow = false" @contextmenu="qrMenu">
                  <div class="download-main-info-right-center">
                    <div class="qrcode">
                      <!-- <img
                        id="qrcode"
                        src="../../assets/images/pc/qrcode.png"
                        alt="千年游戏盒子"
                      /> -->
                      <img id="qrcode" :src="qrcodeUrl" alt="千年游戏盒子" />
                    </div>
                    <div id="qrSize">长按保存 扫码下载</div>
                  </div>
                  <!-- pc 弹窗 -->
                  <div v-if="pcqrShow" class="qrSave">
                    <div @click="saveImage">图片另存为</div>
                    <div @click="handleCopyImg">复制图片</div>
                  </div>
                </div>
                <!-- ipad 弹窗 -->
                <div class="ipad_qrSave" v-if="saveShow">
                  <div @click="savepicture">保存图片</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="base">
      <div class="base-main maxWidth">
        <div class="flex">
          <!-- <div>《用户协议》</div> -->
          <router-link to="yinsi" style="color: white" target="_blank">《隐私政策》</router-link>
          <!-- <a href="./privacy.html" target="_blank">《隐私政策》</a> -->
        </div>
        <div class="base-main_2">
          <span>江阴千游网络科技有限公司</span>
          <span>请您合理控制游戏时间，避免沉溺游戏影响生活，注意自我保护，防范网络陷阱</span>
        </div>
        <div class="flex">
          <a href="https://beian.miit.gov.cn/#/Integrated/index">苏ICP备2022030317号-7</a>
          <div style="margin-left: 0.5rem;"> 违规投诉/举报邮箱：xiecheng1@3975.com
          </div>
          <div style="margin-left: 0.5rem;"> 违规投诉/举报邮箱：jiankongzu2024@163.com
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qywx, WXTest, qq, iosModel } from "@/utils/guidance";
import { isMobile } from "@/utils/index";
import {
  qrcodeUrl,
  downloadA,
} from "@/utils/download";
export default {
  data() {
    return {
      pcqrShow: false,
      saveShow: false,
      qrcodeUrl: qrcodeUrl,
    };
  },
  created() { },
  mounted() { },
  methods: {
    isMobile,
    downloadApp(type) {
      if (qywx || qq || WXTest) {
        this.$emit('guideopen', true)
        return
      }
      switch (type) {
        // pc
        case 1:
          window.location.href = PC_URL;
          break;
        // ios
        case 2:
          this.downloadA(IOS_URL);
          break;
        // android
        case 3:
          window.location.href = ANDROID_URL;
          break;
        case 4:
          window.location.href = ANDROID_URL_MN;
          break;
        default:
          break;
      }
    },
    pcTo() {
      // this.$Message("即将震撼来袭 敬请期待");

    },
    azTo() {

    },
    iosTo() {

    },
    // pc端复制图片到剪切板
    handleCopyImg() {
      let testImg = document.querySelector("#qrcode");
      const selection = window.getSelection();
      // 清除选中
      if (selection.rangeCount > 0) selection.removeAllRanges();
      if (!document.queryCommandSupported("copy"))
        return alert("浏览器暂不支持复制命令");
      // 创建range区域
      const range = document.createRange();
      range.selectNode(testImg);
      selection.addRange(range);
      document.execCommand("copy");
      selection.removeAllRanges();
      this.pcqrShow = false;
    },
    closeQR() {
      this.pcqrShow = false;
      this.saveShow = false;
    },
    // 下载图片
    saveImage() {
      this.pcqrShow = false;
      const dowa = document.createElement("a");
      dowa.href = this.qrcodeUrl;
      dowa.download = "千年游戏盒子";
      document.body.appendChild(dowa);
      dowa.click();
      document.body.removeChild(dowa);
    },
    // 右键保存
    qrMenu(e) {
      e.preventDefault();
      if (!this.isMobile()) {
        this.pcqrShow = !this.pcqrShow;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.download {
  height: 8.475rem
    /* 678/80 */
  ;
  background: #cccccc;
}

.download_box {
  height: 100%;
  background: url("../../assets/images/pc/download-bg.jpg") no-repeat center;
  background-size: cover;
}

.download .download-main {
  width: 15.275rem
    /* 1222/80 */
  ;
  width: 18.75rem
    /* 1500/80 */
  ;
  margin: 0 auto;
}

.download-main-title {
  width: 15rem
    /* 1200/80 */
  ;
  border-bottom: 1px solid #969696;
  color: #000000;
  font-size: 0.45rem
    /* 36/80 */
  ;
  font-weight: 700;
  display: flex;
  align-items: center;
  padding-top: 0.725rem
    /* 58/80 */
  ;
  padding-bottom: 0.3625rem
    /* 29/80 */
  ;
}

.download-main-title span:nth-child(1) {
  width: 0.0625rem
    /* 5/80 */
  ;
  height: 0.375rem
    /* 30/80 */
  ;
  background: #972721;
  margin-right: 0.1rem
    /* 8/80 */
  ;
  margin-top: 0.075rem
    /* 6/80 */
  ;
}

.download-main-info {
  display: flex;
  margin-top: 0.925rem
    /* 74/80 */
  ;
}

.download-main-info>div:nth-child(1) {
  width: 6.25rem
    /* 500/80 */
  ;
  height: 6.25rem
    /* 500/80 */
  ;
  width: 4rem
    /* 320/80 */
  ;
  height: 4rem
    /* 320/80 */
  ;
  flex-shrink: 0;
  margin-right: 1.0875rem
    /* 87/80 */
  ;
  margin-right: 0;
  /* background-size: cover; */
  background: url("../../assets/images/pc/download-main-infobg1.gif") no-repeat center;
  background-size: contain;
}

.download-main-info>div:nth-child(1) img {
  display: block;
  width: 100%;
  height: 100%;
}

.download-main-info .download-main-info-right {
  display: flex;
  align-items: center;
}

.download-main-info .download-main-info-right>div {
  padding-top: 0.4875rem
    /* 39/80 */
  ;
  padding-top: 0.375rem
    /* 30/80 */
  ;

  width: 2.9375rem
    /* 235/80 */
  ;
  height: 3.875rem
    /* 310/80 */
  ;
  width: 2.675rem
    /* 214/80 */
  ;
  width: 2.625rem
    /* 210/80 */
  ;
  height: 3.5rem
    /* 280/80 */
  ;
  background: #ffffff;
  box-shadow: 0px 0.075rem 0.3rem 1px rgba(9, 1, 0, 0.15);
  border-radius: 0.125rem
    /* 10/80 */
  ;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
}

.download-main-info .download-main-info-right>div+div {
  margin-left: 0.25rem
    /* 20/80 */
  ;
}

.qrSave {
  position: absolute;
  right: -59%;
  top: 50%;
  transform: translateY(-50%);
  width: 1.5rem
    /* 120/80 */
  ;
  border-radius: 0.125rem
    /* 10/80 */
  ;
  background: #fff;
  font-size: 0.2rem
    /* 16/80 */
  ;
  color: #000;
  font-weight: bold;
  text-align: center;
}

.qrSave>div {
  padding: 0.375rem
    /* 30/80 */
    0;
  cursor: pointer;
}

.download-main-info .download-main-info-right>div:nth-child(3) {
  padding-top: 0.3875rem
    /* 31/80 */
  ;
}

.download-main-info-right-center .ios {
  width: 1.7875rem
    /* 143/80 */
  ;
  height: 1.6625rem
    /* 133/80 */
  ;
  background: url("../../assets/images/pc/ios.png") no-repeat center;
  background-size: cover;
}

.download-main-info-right-center .android {
  width: 1.7875rem
    /* 143/80 */
  ;
  height: 1.6625rem
    /* 133/80 */
  ;
  background: url("../../assets/images/pc/android.png") no-repeat center;
  background-size: cover;
}
.download-main-info-right-center .mn {
  width: 1.7875rem
    /* 143/80 */
  ;
  height: 1.6625rem
    /* 133/80 */
  ;
  background: url("../../assets/images/pc/mn.png") no-repeat center;
  background-size: cover;
}

.download-main-info-right-center .pc {
  width: 1.7875rem
    /* 143/80 */
  ;
  height: 1.6625rem
    /* 133/80 */
  ;
  background: url("../../assets/images/pc/pc.png") no-repeat center;
  background-size: cover;
  margin: auto;
}

.download-main-info-right-center .qrcode {
  width: 2.2125rem
    /* 177/80 */
  ;
  height: 2.2125rem
    /* 177/80 */
  ;
  background-size: cover;
  margin: 0 auto;
  background: url("../../assets/images/pc/qrcode.png") no-repeat center;
}

.qrcode img {
  display: block;
  width: 100%;
  height: 100%;
}

.accordion_box2 {
  width: 100%;
  position: relative;
}

.download-main-info-right-center div:nth-child(2) {
  font-size: 0.2rem
    /* 22/80 */
  ;
  line-height: 0.275rem
    /* 22/80 */
  ;
  text-align: center;
}

.download-main-info-right-center .iosSize {
  color: #1075af;
}

.download-main-info-right-center .androidSize {
  color: #ff9362;
}

.download-main-info-right-center .pcSize {
  color: #ffcd42;
}

.download-main-info-right-center a {
  margin: 0 auto;
  margin-top: 0.375rem
    /* 30/80 */
  ;
  margin-top: 0.25rem
    /* 20/80 */
  ;
  width: 1.6875rem
    /* 135/80 */
  ;
  height: 0.5625rem
    /* 45/80 */
  ;
  border-radius: 0.125rem
    /* 10/80 */
  ;
  border: 1px solid #000000;
  color: #333333;
  font-size: 0.2rem
    /* 16/80 */
  ;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  cursor: pointer;
}

.download-main-info-right-center #qrSize {
  margin-top: 0.3625rem
    /* 29/80 */
  ;
  margin-top: 0.25rem
    /* 20/80 */
  ;
  color: #000000;
  font-size: 0.2rem
    /* 16/80 */
  ;
  font-weight: 700;
}

.base {
  height: 1.825rem
    /* 146/80 */
  ;
  background: #0b0b0b;
}

.base .base-main {
  margin: 0 auto;
  width: 10.4rem;
  width: 80%;
  padding-top: 0.5rem;
  font-size: 0.2rem;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.base-main a {
  display: block;
  text-align: center;
  font-size: 0.2rem
    /* 16/80 */
  ;
  color: #fff;
}

.base-main_2 span:nth-child(1) {
  margin-right: 0.875rem
    /* 70/80 */
  ;
}
</style>
